<template>
  <info>
    <h1>{{ $t("PRIVACY POLICY") }}</h1>
    <div v-html="$t('PRIVACY_POLICY_DESC_1')"></div>
    <div v-html="$t('PRIVACY_POLICY_DESC_2')"></div>
  </info>
</template>

<script>
import Info from '@/components/Info';

export default {
  components: { Info },
  computed: {
    title() {
      return this.$t('PRIVACY POLICY');
    },
  },
};
</script>
